"use strict";

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var toString = {}.toString;

module.exports = _isArray["default"] || function (arr) {
  return toString.call(arr) == '[object Array]';
};